export enum ProviderType {
  INDIVIDUAL = 'individual',
  FACILITY = 'facility',
}

export type SearchProvidersParams = {
  providerType: ProviderType;
  providerName?: string;
  facilityName?: string;
  npi?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  specialties?: string[];
  pagination?: {
    offset?: number;
    limit?: number;
  };
};

export type ProviderSearchResult = {
  providerName?: string;
  facilityName?: string;
  providerNpi?: string;
  facilityNpi?: string;
  genderName?: string;
  address?: {
    address1?: string;
    address2?: string;
    city?: string;
    state?: string;
    postalCode?: string;
  };
  latitude?: number;
  longitude?: number;
  phoneNumbers?: string[];
  faxNumbers?: string[];
  emailAddresses?: string[];
  specialties?: string[];
};
